import './background.scss'
import { profileData } from "../../data/data"


function Background() {
   return (
      <div className='background'>
         <div className="background__container">
            <div className="background__line background__line-1">
               {profileData.name_line1.split("").map((letter, index) => (
                  <span className={`background__text ${letter.toLocaleUpperCase() !== "Ы" ? "special" : ""}`} key={index}>{letter}</span>
               ))}
            </div>
            <div className="background__line background__line-2">
               {profileData.name_line2.split("").map((letter, index) => (
                  <span className={`background__text ${letter.toLocaleUpperCase() !== "" ? "special" : ""}`} key={index}>{letter}</span>
               ))}
            </div>
         </div>
      </div>
   )
}

export default Background